import { useRuntimeConfig } from '#imports';
import * as Sentry from '@sentry/nuxt';
import pkg from './package.json';

const appVersion = pkg.version;

const { sentryDsn, applicationEnv, clientName } = useRuntimeConfig().public;

// Only initialize Sentry in production or when SENTRY_DSN is provided
if (sentryDsn) {
  const environment = applicationEnv || 'dev';

  Sentry.init({
    dsn: sentryDsn as string,
    environment: `${clientName}-${environment}-client`,
    release: `${appVersion || 'unknown'}`,
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring
    tracesSampleRate: 1,
    profilesSampleRate: 1,
  });
}
